import { IconFileTypeXml } from "@tabler/icons-react";
import { useStartPageElectricityTax } from "../hooks/useStartPageElectricityTax";
import type { MiniTileItem } from "./MiniTile";
import { MiniTile } from "./MiniTile";

type ElectricityTaxMiniTileProps = {
  projectId?: string;
  year: number;
};

function ElectricityTaxMiniTile({
  projectId,
  year
}: ElectricityTaxMiniTileProps) {
  const { data, isLoading } = useStartPageElectricityTax(year, projectId);

  const items: Array<MiniTileItem> = [
    {
      label: "Formularvorlagen",
      value: data?.amount_of_templates
    }
  ];

  return (
    <MiniTile
      icon={<IconFileTypeXml />}
      iconColor="warning"
      isLoading={isLoading}
      items={items}
      title={<>Stromsteuer&shy;dokumente</>}
    />
  );
}

export { ElectricityTaxMiniTile };
